import { CommonHelper } from "../helpers";
export default {
  fillGraphModel(
    graphModel,
    projections,
    projectionPropName,
    firstselectedPropName,
    secondSelectedPropName,
    toolTipOptions,
    isIncludeStartingPoint
  ) {
    let totalProjection = projections.length;
    graphModel.maxYAxis = 0;
    graphModel.minYAxis = 0;

    for (let i = 0; i < totalProjection; i++) {
      for (let j = 0; j < projections[i][projectionPropName].length; j++) {
        if (
          graphModel.maxYAxis <
          projections[i][projectionPropName][j][firstselectedPropName]
        ) {
          graphModel.maxYAxis =
            projections[i][projectionPropName][j][firstselectedPropName];
        }
        if (j == 0 && isIncludeStartingPoint) {
          if (
            graphModel.maxYAxis <
            projections[i][projectionPropName][j][secondSelectedPropName]
          ) {
            graphModel.maxYAxis =
              projections[i][projectionPropName][j][secondSelectedPropName];
          }
          graphModel.data[j].value.push({
            id: `${i}-${j}`,
            value:
              projections[i][projectionPropName][j][secondSelectedPropName],
          });
          graphModel.toolTipData[j].value.push({
            id: `${i}-${j}`,
            value: this.getToolTipData(
              projections[i][projectionPropName][j],
              toolTipOptions
            ),
          });
        }
        if (
          graphModel.minYAxis <
          -projections[i][projectionPropName][j][firstselectedPropName]
        ) {
          graphModel.minYAxis =
            -projections[i][projectionPropName][j][firstselectedPropName];
        }

        graphModel.data[isIncludeStartingPoint ? j + 1 : j].value.push({
          id: `${i}-${j}`,
          value: projections[i][projectionPropName][j][firstselectedPropName],
        });
        graphModel.toolTipData[isIncludeStartingPoint ? j + 1 : j].value.push({
          id: `${i}-${j}`,
          value: this.getToolTipData(
            projections[i][projectionPropName][j],
            toolTipOptions
          ),
        });
      }
    }
  },

  initializeLineGraphWithDefaultValue(startYear, endYear) {
    let graphModel = {
      data: [],
      toolTipData: [],
      domainX: [0, endYear - startYear],
    };
    for (let i = startYear; i <= endYear; i++) {
      graphModel.data.push({ id: i-1, value: [] });
      graphModel.toolTipData.push({ id: i-1, value: [] });
    }
    return graphModel;
  },
  initializeBarGraphWithDefaultValue(startYear, endYear) {
    let graphModel = {
      data: [],
      toolTipData: [],
      domainX: [],
    };
    for (let i = startYear; i < endYear; i++) {
      graphModel.domainX.push(i );
      graphModel.data.push({ id: i , value: [] });
      graphModel.toolTipData.push({ id: i , value: [] });
    }
    return graphModel;
  },

  getToolTipData(projection, options) {
    let tooltipData = {};
    for (let i = 0; i < options.length; i++) {
      tooltipData[options[i].name] = projection[options[i].id]
        ? options[i].isCurrencyType
          ? CommonHelper.convertIntoCurrencyWithoutDecimal(
              projection[options[i].id]
            )
          : projection[options[i].id]
        : options[i].isCurrencyType
        ? CommonHelper.convertIntoCurrencyWithoutDecimal(0)
        : "";
    }
    return tooltipData;
  },

  getChartToolTipPro(compareOption) {
    let toolTipPro = [];
    for (let i = 0; i < compareOption.toolTipPro.length; i++) {
      if (!compareOption.toolTipPro[i].ishide)
        toolTipPro.push(compareOption.toolTipPro[i]);
    }
    return toolTipPro;
  },

  getChartProperties(
    maxYAxis,
    colors,
    legendItems,
    width,
    domainX,
    toolTipBoxWidth,
    labelNameY,
    minYAxis
  ) {
    let roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
      0,
      Math.ceil(maxYAxis),
      5
    );
    if (roundOffYaxis < 5) {
      roundOffYaxis = 5;
    }
    let roundOffYMinaxis =
      minYAxis > 0
        ? -CommonHelper.getRoundOffValueForAxis(0, Math.ceil(minYAxis), 5)
        : 0;
    return {
      rangeX: [0, width],
      rangeY: [300, 0],
      width: width,
      domainX: domainX,
      domainY: [roundOffYMinaxis, roundOffYaxis],
      tickQuantityY: 5,
      color: colors,
      legendItems: legendItems,
      legendKeyType: "bar",
      areaLegendKey: "bar",
      currencyFormat: ".2s",
      height: 300,
      tickX: 0,
      axisLeftWidth: 100,
      axisRightWidth: 100,
      isHideFirstTick: true,
      labelNameY: labelNameY,
      toolTipBoxWidth: toolTipBoxWidth,
    };
  },
  getGraphLegends(
    projections,
    selectedInstances,
    uniqueIdProName,
    colors,
    startingYear
  ) {
    let totalProjection = projections.length;
    let legends = [];
    let legendColors = [];
    let tooltipHeader = [];
    tooltipHeader.push({ value: startingYear, type: "text" });
    for (let i = 0; i < totalProjection; i++) {
      let selectedInstance = selectedInstances.filter(
        (sr) => sr.uniqueId == projections[i][uniqueIdProName]
      );
      if (selectedInstance.length == 0) {
        continue;
      }
      legends.push(selectedInstance[0].description);
      legendColors.push(colors[i]);
      tooltipHeader.push({
        value: selectedInstance[0].description,
        type: "legendText",
        color: colors[i],
      });
    }
    return {
      chartLegends: legends,
      chartLegendColors: legendColors,
      charttooltipHeader: tooltipHeader,
    };
  },
};
